import React, { Component } from 'react'
import { connect } from 'react-redux'
import classes from './MarksToolbar.module.scss';

import { setDisplayType, setLength } from '../../../redux/marks/actions';
import { SimpleSelect } from '../../../common'


class MarksToolbar extends Component {

  handleClick = (value) =>{
    this.props.setDisplayType(value)
  }
  handleLengthChange = (event) =>{
    this.props.setLength(event.target.value);
  }
  render() {
      const lengthoptions = [
        {value:3, label:3},
        {value:6, label:6},
        {value:9, label:9},
        {value:12, label:12},
        {value:24, label:24},
        {value:48, label:48},
        {value:96, label:96},
        {value:192, label:192}
      ];
      return(
          <div className={classes.Toolbar}>
            <div>{this.props.total} marks</div>

            <div className={classes.Right}>
              <div><SimpleSelect onChange={this.handleLengthChange} value={this.props.length} options={lengthoptions}><span className={ classes.Nomobile }> results </span>per page</SimpleSelect></div>
              <div><span className={ classes.Nomobile }>View</span><button onClick={()=>{this.handleClick("cards")}} >{ this.props.displaytype && this.props.displaytype==="cards" ? <img alt="" src={require('../../../assets/img/cards_on.svg')}  />:<img alt="" src={require('../../../assets/img/cards_off.svg')}  /> }</button>
              <button onClick={()=>{this.handleClick("list")}} >{ this.props.displaytype && this.props.displaytype==="list" ? <img alt="" src={require('../../../assets/img/list_on.svg')}  />:<img alt="" src={require('../../../assets/img/list_off.svg')}  /> }</button>
              </div>
            </div>
          </div>
      );
  }
}

const mapStateToProps = (state)=>{
  return {
    total: state.marks.total,
    length:state.marks.length,
    displaytype:state.marks.displaytype
  }
};

export default connect(mapStateToProps, {setDisplayType, setLength})(MarksToolbar);